import { ComponentProps } from 'react';
import { useFormContext, Controller, RegisterOptions } from 'react-hook-form';

import { DatePicker } from '@restworld/ui-ds-base';
import { useWorkerApplicationCxt } from '../worker-application-wizard.context';

interface WizardDateFieldProps extends Omit<ComponentProps<typeof DatePicker>, 'onChange'> {
  errorMessage?: string;
  id: string;
  rules?: RegisterOptions;
  testId?: string;
}
export const WizardDateField = ({ id, rules, errorMessage, ...rest }: WizardDateFieldProps) => {
  const { control } = useFormContext();
  const { errorsTextMap } = useWorkerApplicationCxt();
  const errorMessageCopy = errorMessage || errorsTextMap[id];
  return (
    <Controller
      name={id}
      control={control}
      rules={rules}
      render={({ field }) => {
        return (
          <DatePicker
            id={id}
            selectRange={false}
            helperText={errorMessageCopy}
            fieldState={errorMessageCopy ? 'error' : 'normal'}
            {...field}
            {...rest}
          />
        );
      }}
    />
  );
};
